import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/charts";
import axios from "axios";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "../tester-teamlead/statsModalContent.css";

const roleStatsBase = process.env.REACT_APP_API_RoleBasedOTPStats
  ? String(process.env.REACT_APP_API_RoleBasedOTPStats).replace(/\/$/, "")
  : "";

/**
 * Day-wise OTP chart for a role-based tester (super admin detail dialog).
 * Uses same API as tester dashboard: POST tester-opts-count-day-wise.
 */
const RoleBasedTesterStatsDetail = ({ testerId }) => {
  const apiUrl = roleStatsBase ? `${roleStatsBase}/tester-opts-count-day-wise` : "";
  const [data, setData] = useState([]);
  const [selectedRange, setSelectedRange] = useState(() => {
    const end = new Date();
    const start = new Date(end.getFullYear(), end.getMonth(), 1);
    return [start, end];
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!apiUrl || !testerId || selectedRange.length !== 2) return;
      try {
        const response = await axios.post(apiUrl, {
          start_date: selectedRange[0].toISOString().split("T")[0],
          end_date: selectedRange[1].toISOString().split("T")[0],
          tester_id: testerId,
        });
        if (response.data?.inactive) {
          setData([]);
          return;
        }
        const optCount = response.data?.opt_count ?? {};
        const dates = [];
        const cur = new Date(selectedRange[0]);
        const end = new Date(selectedRange[1]);
        while (cur <= end) {
          dates.push(cur.toISOString().split("T")[0]);
          cur.setDate(cur.getDate() + 1);
        }
        setData(
          dates.map((date) => ({
            type: date,
            value: optCount[date] !== undefined ? optCount[date] : null,
          })),
        );
      } catch (error) {
        console.error("Error fetching role-based tester stats:", error);
        setData([]);
      }
    };
    fetchData();
  }, [selectedRange, testerId, apiUrl]);

  const handleDateChange = (ranges) => {
    const startDate = ranges.selection.startDate;
    const endDate = ranges.selection.endDate;
    setSelectedRange([startDate, endDate]);
  };

  if (!apiUrl) {
    return (
      <div className="tester-stats-modal-content" style={{ padding: 16 }}>
        REACT_APP_API_RoleBasedOTPStats is not configured.
      </div>
    );
  }

  const config = {
    data,
    xField: "type",
    yField: "value",
    height: 380,
    xAxis: {
      label: {
        formatter: (val) => {
          const date = new Date(val);
          return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
        },
      },
    },
    style: { fill: "#38bdf8" },
    label: {
      text: (originData) => {
        const val = parseFloat(originData.value);
        if (val < 0.05) {
          return (val * 100).toFixed(1);
        }
        return "";
      },
      offset: 10,
    },
    legend: false,
  };

  return (
    <div className="tester-stats-modal-content">
      <div className="tester-stats-date-picker-wrap">
        <DateRangePicker
          onChange={handleDateChange}
          moveRangeOnFirstSelection={false}
          months={1}
          ranges={[
            {
              startDate: selectedRange[0],
              endDate: selectedRange[1],
              key: "selection",
            },
          ]}
          rangeColors={["#38bdf8"]}
          color="#38bdf8"
        />
      </div>
      <div className="tester-stats-chart-wrap">
        <Column {...config} />
      </div>
    </div>
  );
};

export default RoleBasedTesterStatsDetail;
